<template>
  <div>
    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">
          출퇴근 시간 변경 신청일
        </v-list-item-subtitle>
        <v-list-item-title class="app-desc">{{ mapPeriod }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label"
          >변경 후 출근시간</v-list-item-subtitle
        >
        <v-list-item-title class="app-desc">{{ mapSHm }}</v-list-item-title>
      </v-list-item-content>
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label"
          >변경 후 퇴근시간</v-list-item-subtitle
        >
        <v-list-item-title class="app-desc">{{ mapEHm }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item two-line flat class="px-5">
      <v-list-item-content>
        <v-list-item-subtitle class="mb-1 app-label">비고</v-list-item-subtitle>
        <v-list-item-content class="app-desc">{{
          GET_MAP_REASON
        }}</v-list-item-content>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import viewerMixin from '@/mixins/viewerMixin.js';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

export default {
  mixins: [viewerMixin],
  data: () => ({}),
  computed: {
    ...mapGetters(['GET_USER_DATA']),
    // 기간
    mapPeriod() {
      const ymd = this.GET_APP_MAP_DATA.ymd;
      if (ymd === undefined || ymd === null) return '-';
      return dayjs(this.GET_APP_MAP_DATA.ymd).format('YYYY-MM-DD');
    },
    mapSHm() {
      const sHm = this.GET_APP_MAP_DATA.afShm;
      if (sHm === undefined || sHm === null) return '-';
      return `${sHm.substr(0, 2)}:${sHm.substr(2, 2)}`;
    },
    mapEHm() {
      const eHm = this.GET_APP_MAP_DATA.afEhm;
      if (eHm === undefined || eHm === null) return '-';
      return `${eHm.substr(0, 2)}:${eHm.substr(2, 2)}`;
    },
  },
  props: {
    appInfoParam: Object,
  },
  methods: {
    // 신청 상세 내용 조회
    async fetchApplicationMap() {
      this.ON_APP_SPINNER(); // 스피너 ON
      await this.$store.dispatch('ELA/FETCH_ATTEND_MAP', {
        searchApplSeq: this.appInfoParam.applSeq,
        searchApplSabun: this.appInfoParam.applSabun,
      });
      this.OFF_APP_SPINNER(); // 스피너 OFF
    },
  },
  mounted() {
    // console.log('attend viewer data mounted');
    this.fetchApplicationMap();
  },
};
</script>

<style></style>
